<template>
  <TheLayout>
    <DetectorTable />
  </TheLayout>
</template>

<script setup>
import DetectorTable from "@/components/DetectorTable.vue";
import TheLayout from "@/layouts/TheLayout.vue";
</script>

<style scoped>

</style>